export default __webpack_public_path__ + "static/media/mission.9e565176.jpg";